import React, { memo, useCallback } from 'react';
import { formatPhone } from '../models/groceryModels';
import './GroceryComponents.css';

const GroceryDonorForm = ({ donor, errors, onChange }) => {
  const handleField = useCallback(
    (field) => (event) => onChange(field, event.target.value),
    [onChange]
  );

  const handlePhone = useCallback(
    (event) => onChange('phone', formatPhone(event.target.value)),
    [onChange]
  );

  const fieldClass = (field, base) => `${base}${errors[field] ? ' has-error' : ''}`;

  return (
    <div className="grocery-form-grid">
      <div className="grocery-field">
        <label className="grocery-label" htmlFor="grocery-first-name">
          First Name <span className="grocery-required">*</span>
        </label>
        <input
          id="grocery-first-name"
          className={fieldClass('firstName', 'grocery-input')}
          value={donor.firstName}
          onChange={handleField('firstName')}
          autoComplete="given-name"
        />
        {errors.firstName && <span className="grocery-error-text">{errors.firstName}</span>}
      </div>

      <div className="grocery-field">
        <label className="grocery-label" htmlFor="grocery-last-name">
          Last Name <span className="grocery-required">*</span>
        </label>
        <input
          id="grocery-last-name"
          className={fieldClass('lastName', 'grocery-input')}
          value={donor.lastName}
          onChange={handleField('lastName')}
          autoComplete="family-name"
        />
        {errors.lastName && <span className="grocery-error-text">{errors.lastName}</span>}
      </div>

      <div className="grocery-field">
        <label className="grocery-label" htmlFor="grocery-email">
          Email <span className="grocery-required">*</span>
        </label>
        <input
          id="grocery-email"
          type="email"
          className={fieldClass('email', 'grocery-input')}
          value={donor.email}
          onChange={handleField('email')}
          autoComplete="email"
        />
        {errors.email && <span className="grocery-error-text">{errors.email}</span>}
      </div>

      <div className="grocery-field">
        <label className="grocery-label" htmlFor="grocery-phone">
          Phone <span className="grocery-required">*</span>
        </label>
        <input
          id="grocery-phone"
          type="tel"
          className={fieldClass('phone', 'grocery-input')}
          value={donor.phone}
          onChange={handlePhone}
          placeholder="(555) 555-5555"
          autoComplete="tel"
        />
        {errors.phone && <span className="grocery-error-text">{errors.phone}</span>}
      </div>

      <div className="grocery-field grocery-field-full">
        <label className="grocery-label" htmlFor="grocery-instructions">
          Special Instructions
        </label>
        <textarea
          id="grocery-instructions"
          className="grocery-textarea"
          value={donor.specialInstructions}
          onChange={handleField('specialInstructions')}
          placeholder="Anything the temple team should know about your donation"
        />
      </div>
    </div>
  );
};

export default memo(GroceryDonorForm);
